import React from "react";
import { WedIcon } from "../../wed-icon/WedIcon";
import { WedIconUsers } from "../../wed-icon/generated/WedIconSvg";
import "../count-icon.scss";

interface PropsInterface {
    count: number;
}

interface StateInterface {}

export default class InternalTeamCountIcon extends React.Component<PropsInterface, StateInterface> {
    render() {
        const { count } = this.props;

        return (
            <div className="count-icon team-count-icon">
                <WedIcon icon={<WedIconUsers />} />
                <span className="count-icon__content">{count}</span>
            </div>
        );
    }
}
